import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import analytics from "util/analytics";
import 'video.js/dist/video-js.min.css';
import '@videojs/themes/dist/sea/index.css';
import videojs from 'video.js'
import 'videojs-contrib-hls'
import './VideoPlayer.scss'
import Vimeo from '@u-wave/react-vimeo';
import YouTube from '@u-wave/react-youtube';


const options = {
  fill: true,
  fluid: true,
  responsive: true,
  preload: 'auto',
  controls: true
};

const VideoPlayer = ({ src = '', type = 'video/mp4', playback_id, classId, instructorId, instructor, previewImage}) => {
  const videoRef = useRef(null);
  const [player, setPlayer] = useState(null);

  console.log("VIDEO SOURCE: ", src)
  console.log("VIDEO TYPE: ", type)
  if (type === 'video/quicktime') {
    type = 'video/mp4'
  }
  

  useEffect(() => {
    if (type.includes('vimeo') || type.includes('youtube')) {
      return
    }
    const vjsPlayer = videojs(videoRef.current, {
      ...options,
      poster: previewImage
    });
    setPlayer(vjsPlayer);

    vjsPlayer.on('playing', function() {
      analytics.track("Play Video", {
        instructor: instructor ?? "unknown",
        instructorId: instructorId ?? "unknown",
        classId: classId ?? "unknown"
      })
    });

    return () => vjsPlayer.dispose();
  }, []);

  useEffect(() => {
    if (type.includes('vimeo') || type.includes('youtube')) {
      return
    }
    if (player !== null) {
      if (playback_id) {
        const source = `https://stream.mux.com/${playback_id}.m3u8`;
        player.src(source)
      } else {
        player.src({ src, type });
      }
      
    }
  }, [playback_id, src, type, player]);

  if (['video/vimeo'].includes(type)) {
    return (
      <div className="widescreen-wrapper">
        <Vimeo
          className="vimeo-video"
          video={src}
        />
      </div>      
    )
  }

  if (['video/youtube'].includes(type)) {
    return (
      <div className="widescreen-wrapper">
        <YouTube
          className="vimeo-video"
          video={src}
        />
      </div>      
    )
  }

  return (
    <div onContextMenu={e => e.preventDefault()} style={{ width: "100%" }}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video ref={videoRef} className="video-js vjs-16-9 vjs-theme-forest" controlsList="nodownload" oncontextmenu="return false;">
        <p className="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a href="https://videojs.com/html5-video-support/">
            supports HTML5 video
          </a>
        </p>
      </video>
    </div>
  );
};

export default VideoPlayer